<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <div
          class="items"
          v-scroll-spy-link="{ selector: 'a', class: 'btn-primary' }"
          v-scroll-spy-active="{ selector: 'a div', class: 'btn-primary' }"
        >
          <div class="items">
            <a href="#list">
              <div class="btn w-100 btn-simple text-start">
                {{ $t("problemCategory.warehouseProblem") }}
              </div>
            </a>
          </div>
        </div>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10" v-scroll-spy="{ offset: 120 }">
      <section id="list">
        <h2>{{ $t("leftSidebar.tool-modules") }}</h2>
        <h4>{{ $t("problemCategory.warehouseProblem") }}</h4>
        <OneByOneTable
          v-model:rows="rows"
          v-model:items="items"
          type="row"
          :show-edit="true"
          v-on:edit="rowModal"
          v-on:addbtn="rowModal"
          v-on:delete="deleteRowModal"
        />
        <ProblemCategoryModal
          ref="editModal"
          v-model="selectedRow"
          v-on:newItem="addItem"
          v-on:update:modelValue="updateItem"
        />
        <ConfirmModal
          ref="rowDeleteModal"
          :title="$t(`customRows.deleteRow`)"
          :text="`<ul><li>You will delete ${deleteObject?.name}<b></li><li>You can't undo this action</li></ul><p>Are you sure you want to delete?</p>`"
          :cancel-button="`No, keep ${deleteObject?.name}`"
          :ok-button="`Yes, delete ${deleteObject?.name}`"
          v-on:success="deleteRow"
        />
      </section>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";
import OneByOneTable from "../lists/OneByOneTable";
import ProblemCategoryModal from "../modals/ProblemCategoryModal";
import ConfirmModal from "../modals/ConfirmModal";

export default {
  name: "Problems",
  components: { ConfirmModal, ProblemCategoryModal, OneByOneTable },
  data() {
    return {
      deleteObject: {},
      rows: [
        {
          name: "ID",
          key: "id",
          type: "id",
          show: true,
        },
        {
          name: "Name",
          key: "name",
          type: "string",
          show: true,
        },
        {
          name: "Description",
          key: "description",
          type: "string",
          show: true,
        },
      ],
      items: [],
      selectedRow: undefined,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.items = [];
      http.fetch("/orders/problem-categories").then((data) => {
        this.items = data;
      });
    },
    addItem(data) {
      this.items.unshift(data);
    },
    updateItem(data) {
      const index = this.items.findIndex((e) => e.id === data.id);
      if (index !== -1) {
        this.items[index] = data;
      }
    },
    rowModal(id) {
      if (id) {
        this.selectedRow = this.items.find((e) => e.id === id);
      } else {
        this.selectedRow = undefined;
      }
      this.$refs.editModal.showModal();
    },
    deleteRow() {
      http
        .fetch(
          "/orders/problem-categories/" + this.deleteObject.id,
          {},
          true,
          "DELETE"
        )
        .then(() => {
          let i = this.items.indexOf(this.deleteObject);
          if (i > -1) {
            this.items.splice(i, 1);
          }
        });
    },
    deleteRowModal(e) {
      this.deleteObject = e;
      this.$refs.rowDeleteModal.showModal();
    },
  },
};
</script>
